module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAECSURBVFiF7dTRFYIwDAXQF1zESfR0EzcRJuPYSVxEnz8FFVCSpuJP3w8CktxTUoCampqajESeEHn6NwMA0FzYSiQlks2FrbeeeDEUnN8KEt39KO3moCVMCVQWaIoRogOA6TXPSpkww8xM5+bbvc0xm6MsjX6OymmQi1INtURy/G0Y1unw8yCr/RoVKO0i6865H6V9fVbVS1v8Y3ruZYceAHhDQJCrp5wP9MTs05WrF5UPmmOGuFB5oIWVScfxPBdlB316TQBKvD4baG1mCsyUHqRt5kTpQNYmDpTuw2gtHmSYq+E/47eqCOgl+uWfo1RRgXhDINGZd01Cjc/W1NTUzPMAbpMVHJl9rW0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/marker/up-icon.png
// module id = nRWH
// module chunks = 1